<header class="header" [class.fixed]="this.headerFixo" [class.contraste]="this.contrasteAtivo">
    <div class="wrapper">
        <nav class="header__navigation">
          <div class="header__navigation--inner">
              <div class="navigation__logo" style="background-image: url(../../../../assets/img/logos/logo-bullest.png);">
                  <a (click)="scrollToSection('#banner__home')" class="logo-link"></a>
              </div>
              <div class="navigation__logo navigation__logo--contraste" style="background-image: url(../../../../assets/img/logos/logo-bullest-contrast.png);">
                  <a (click)="scrollToSection('#banner__home')" class="logo-link"></a>
              </div>
              <div class="header--mobile">
                  <button class="header__menuMobile" (click)="toggleMenuMobile()" [class.menuMobileOpen]="this.menuMobileOpen"></button>
              </div>
          </div>
            <div class="navigation__links" [class.menuMobileOpen]="this.menuMobileOpen" [class.active]="this.menuAcessibilidadeOpen">
                <a (click)="scrollToSection('#sobreNos')" class="header__navigation-link" [hidden]="this.esconderMenu">Sobre Nós</a>
                <a (click)="scrollToSection('#servicos')" class="header__navigation-link" [hidden]="this.esconderMenu">Serviços</a>
                <a (click)="scrollToSection('#clientes')" class="header__navigation-link" [hidden]="this.esconderMenu">Clientes</a>
                <!-- <a (click)="scrollToSection('#depoimentos')" class="header__navigation-link" [hidden]="this.esconderMenu">Depoimentos</a> -->
                <!-- <a (click)="scrollToSection('#feed')" class="header__navigation-link" [hidden]="this.esconderMenu">Feed</a> -->
                <a (click)="scrollToSection('#faq')" class="header__navigation-link" [hidden]="this.esconderMenu">FAQ</a>
                <a (click)="scrollToSection('#contato')" class="header__navigation-link" [hidden]="this.esconderMenu">Contato</a>

                <div class="acessibilidade" [class.active]="this.menuAcessibilidadeOpen" title="acessibilidade">
                    <a (click)="toggleMenuAcessibilidade()" class="header__navigation-link header__navigation-link--acessibilidade">
                        <span class="acessibilidade-icon">
                            Acessibilidade
                            <i class="fas fa-chevron-down" [class.rotate]="!this.menuAcessibilidadeOpen">
                            </i>
                        </span>
                    </a>
                    <div class="acessibilidadeMenu" [class.acessibilidadeMenu--open]="this.menuAcessibilidadeOpen">
                        <div class="acessibilidade-fonte">
                            <button class="btn-acessibilidadeMenu" title="Normalizar" (click)="defaultFonte()">A<i
                                    class="fas fa-undo icon-undo"></i></button>
                            <button class="btn-acessibilidadeMenu" title="Diminuir fonte" (click)="diminuirFonte()" [disabled]="this.diminuirFonteDisabled">A-</button>
                            <button class="btn-acessibilidadeMenu" title="Aumentar fonte" (click)="aumentarFonte()" [disabled]="this.aumentarFonteDisabled">A+</button>
                        </div>
                        <button class="btn-acessibilidadeMenu" title="Contrastar" (click)="contrasteToggle()" [class.active]="this.contrasteAtivo">
                            <i class="fas fa-adjust"></i> Contraste
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</header>
